import { FunctionComponent } from "react";

export interface PmcLogoProps {
  className?: string;
}

const PmcLogo: FunctionComponent<PmcLogoProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 177 23"
      fill="none"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M177.1 23H135.8C130.9 23 127.1 20.9 127.1 15.8V7.6C127.1 2.3 130.1 0 135.9 0H177V3.2H136C132.9 3.2 130.5 4.2 130.5 7.7V15.6C130.5 18.3 132.5 19.8 135.7 19.8H177.1V23Z"
        fill="currentColor"
      />
      <path
        d="M49.9 8.3C49.9 11.8 46.9 13.5 43.4 13.5H3.5V23H0V10.4H43.5C45.4 10.4 46.4 9.7 46.4 7.9V5.7C46.4 3.8 45.5 3.3 43.5 3.3H0V0H43.9C47.1 0 49.8 1.3 49.8 4.6V8.3H49.9Z"
        fill="currentColor"
      />
      <path d="M57.6 23H61.1V6.6L57.6 4.9V23Z" fill="currentColor" />
      <path
        d="M88.5 13.2L61.1 0H57.6V2.2L85.2 15.5C86.4 16 87.4 16.2 88.5 16.2V13.2Z"
        fill="currentColor"
      />
      <path d="M115.9 6.6V23H119.4V4.9L115.9 6.6Z" fill="currentColor" />
      <path
        d="M88.5 13.2L115.9 0H119.4V2.2L91.8 15.5C90.6 16 89.6 16.2 88.5 16.2V13.2Z"
        fill="#EC2026"
      />
    </svg>
  );
};

export default PmcLogo;
